import { render, staticRenderFns } from "./ServiceMenuStatusIconWithLink.vue?vue&type=template&id=53b467fc&scoped=true&"
import script from "./ServiceMenuStatusIconWithLink.vue?vue&type=script&lang=ts&"
export * from "./ServiceMenuStatusIconWithLink.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceMenuStatusIconWithLink.vue?vue&type=style&index=0&id=53b467fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b467fc",
  null
  
)

export default component.exports